import { formatNumber } from '@weft/utils';
import type { ColumnDefinition } from 'apps/app/src/components/design/table/table-components/table-body/table-body-components/table-row/table-row-components/table-cell/table-cell-types/column-definition';
import { TableToCell } from '../../../components/design/table/table-components/table-body/table-body-components/table-row/table-row-components/table-cell/TableToCell';
import { EMPTY_TIER_DATA } from './invoice-consts';
import type { CommitmentLineItemTierRow } from './invoice-types/commitment-line-item-tier-row';

export function buildCommitmentLineItemTiersTableColumns(currencySymbol: string): ColumnDefinition<CommitmentLineItemTierRow>[] {
  return [
    {
      headerClassName: 'text-left w-fit',
      header: 'from',
      renderCell: ({ from }) => (
        <p className='text-left'>
          {formatNumber(from)}
        </p>
      ),
    },
    {
      headerClassName: 'text-center w-fit',
      header: 'to',
      renderCell: ({ to }) => (
        <TableToCell
          to={to}
          className='top-1.5 w-full text-center'
        />
      ),
    },
    {
      header: 'Rate',
      headerClassName: 'text-center w-fit',
      renderCell: ({ rate }) => (
        <p className='text-center'>
          {`${currencySymbol}${formatNumber(rate)}`}
        </p>
      ),
    },
    {
      header: 'YTD QTY',
      headerClassName: 'text-right w-fit',
      renderCell: ({ ytdUnits }) => {
        return (
          <p className='text-right'>
            {ytdUnits > 0 ? formatNumber(ytdUnits) : EMPTY_TIER_DATA}
          </p>
        );
      },
    },
    {
      header: 'Period QTY',
      headerClassName: 'text-center w-fit',
      renderCell: ({ periodUnits }) => (
        <p>
          {periodUnits > 0
            ? formatNumber(periodUnits)
            : EMPTY_TIER_DATA
            }
        </p>
      ),
    },
    {
      header: 'Billable QTY',
      headerClassName: 'text-center w-fit',
      renderCell: ({ billableUnits }) => (
        <p>
          {billableUnits > 0
            ? formatNumber(billableUnits)
            : EMPTY_TIER_DATA
              }
        </p>
      ),      
    },
    {
      header: 'Amount',
      headerClassName: 'text-right w-fit',
      renderCell: ({ billableUnits, price }) => (
        <p className='text-right'>
          {billableUnits > 0
            ? `${currencySymbol}${formatNumber(price)}`
            : EMPTY_TIER_DATA
          }
        </p>
      ),
    },
  ];
}